import React, { useState } from "react";
import {
  Form,
  Title,
  Input,
  InputGroup,
  Label,
  Timer,
} from "styles/common/FormStyle";
import { CommonWrapper, Background } from "styles/common/Layout";
import { ButtonOutline } from "styles/common/ButtonStyle";
import { sendSMSToUser, verifySMS } from "api/message";
import { findPassword } from "api/user";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    0: {
      userId: "",
      phoneNumber: "",
      code: "",
      logId: "",
    },
    1: {
      password: "",
      confirmPassword: "",
    },
  });
  const [step, setStep] = useState(0);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm({ ...form, [step]: { ...form[step], [name]: value } });
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const completeForm =
    Object.values(form[step]).every((value) => value) && step === 1
      ? form[1]?.password === form[1]?.confirmPassword
      : true;

  const [isMessageSent, setIsMessageSent] = useState(false);
  const [isMessageVerified, setIsMessageVerified] = useState(false);
  const [timer, setTimer] = useState(0);

  const countDown = () => {
    setTimer(180);
    const interval = setInterval(() => {
      setTimer((timer) => timer - 1);
    }, 1000);
    setTimeout(() => {
      clearInterval(interval);
    }, 180000);
  };

  // show seconds as mm:ss
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  };

  const sendMessage = async () => {
    try {
      const { userId, phoneNumber } = form[0];
      await sendSMSToUser(userId, phoneNumber);
      setIsMessageSent(true);
      setIsMessageVerified(false);
      countDown();
      alert("인증번호가 전송되었습니다.");
    } catch (err) {
      alert(err);
    }
  };

  const verifyMessage = async () => {
    try {
      const { phoneNumber, code } = form[0];
      const res = await verifySMS(phoneNumber, code);
      const logId = res?.data?.logId;
      form[0].logId = logId;
      setForm(form);
      setIsMessageVerified(true);
      alert("인증되었습니다.");
      nextStep();
    } catch (err) {
      alert(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { userId, logId, phoneNumber } = form[0];
      const { password, confirmPassword } = form[1];

      if (password !== confirmPassword) {
        alert("비밀번호가 일치하지 않습니다.");
        return;
      }

      await findPassword({ userId, logId, password, phoneNumber });
      alert("비밀번호가 변경되었습니다.");
      navigate("/");
    } catch (error) {
      alert(error);
    }
  };

  return (
    <Background>
      <CommonWrapper>
        {isMessageVerified && step === 1 ? (
          <Form onSubmit={handleSubmit}>
            <Title>비밀번호 재설정</Title>
            <Label htmlFor="password">새 비밀번호</Label>
            <Input
              type="password"
              id="password"
              name="password"
              value={form[1]?.password}
              onChange={handleChange}
              placeholder="비밀번호를 입력해주세요."
            />
            <Label htmlFor="confirmPassword">비밀번호 확인</Label>
            <Input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={form[1]?.confirmPassword}
              onChange={handleChange}
              placeholder="비밀번호를 다시 입력해주세요."
            />
            <ButtonOutline type="submit" disabled={!completeForm}>
              확인
            </ButtonOutline>
          </Form>
        ) : (
          <Form>
            <Title>비밀번호 찾기</Title>
            <Label htmlFor="userId">아이디</Label>
            <Input
              type="userId"
              id="userId"
              name="userId"
              value={form[0]?.userId}
              onChange={handleChange}
              placeholder="아이디를 입력해주세요."
            />
            <Label htmlFor="userId">휴대폰 번호</Label>
            <InputGroup>
              <Input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                value={form[0]?.phoneNumber}
                onChange={handleChange}
                placeholder="휴대폰 번호를 입력해주세요."
                disabled={isMessageSent}
              />
              <ButtonOutline
                type="button"
                onClick={sendMessage}
                width="160px"
                height="40px"
                margin="0 0 0 10px"
                disabled={isMessageVerified}
              >
                {isMessageSent ? "재전송" : "인증번호 받기"}
              </ButtonOutline>
            </InputGroup>
            {isMessageSent && (
              <>
                <Label htmlFor="code">인증번호</Label>
                <InputGroup>
                  <Input
                    type="text"
                    id="code"
                    name="code"
                    value={form[0]?.code}
                    onChange={handleChange}
                    placeholder="인증번호를 입력해주세요."
                    disabled={isMessageVerified}
                  />
                  {isMessageSent && !isMessageVerified && (
                    <Timer right="20px">{formatTime(timer)}</Timer>
                  )}
                </InputGroup>
                <ButtonOutline
                  type="button"
                  onClick={verifyMessage}
                  disabled={!completeForm}
                >
                  확인
                </ButtonOutline>
              </>
            )}
          </Form>
        )}
      </CommonWrapper>
    </Background>
  );
};

export default ForgotPassword;
